// src/components/TermsOfUse.jsx
import React from "react";
import { Container } from "react-bootstrap";
import "./TermsOfUse.css";

const TermsOfUse = () => {
  return (
    <section className="terms-section">
      <Container>
        <h1 className="terms-title">Terms of Use</h1>
        <p>
          The User shall be deemed to have accepted and agreed to the following
          terms and conditions upon the User’s usage of the website{" "}
          <a
            href="https://www.stratedge.com"
            target="_blank"
            rel="noreferrer"
          >
            www.stratedge.com
          </a>
        </p>
        <ul className="terms-list">
          <li>
            The term "User" shall mean the User who is browsing the website
            www.stratedge.com (Site).
          </li>
          <li>
            The domain address www.stratedge.com is owned by Strat Edge Private
            Limited. All content present on this Site, including all the
            software, text, images, graphics, video, and audio used on this
            Site, is exclusive and proprietary material owned by Strat Edge.
          </li>
          <li>
            The Strat Edge name and logo are trademarks which belong to and are
            owned by Strat Edge Private Limited. These trademarks may not be
            used in any manner whatsoever without prior written consent from
            Strat Edge.
          </li>
          <li>
            Strat Edge may unilaterally change or discontinue any aspect of the
            Site at any time, including its content or features.
          </li>
          <li>
            Strat Edge will not be liable for damages of any kind, including
            without limitation, direct, indirect, incidental, or consequential
            damages (including, but not limited to, damages for lost profits,
            business interruption, and loss of programs or information) arising
            out of the use of or inability to use the Site, or any information
            provided on the Site, or for any other reason whatsoever.
          </li>
          <li>
            The User agrees to indemnify, defend, and hold Strat Edge harmless
            from and against all losses, expenses, damages, and costs, including
            reasonable attorneys' fees, arising out of or relating to any misuse
            by the User of the content and services provided on the Site.
          </li>
          <li>
            The information contained in the Site has been obtained from sources
            believed to be reliable. Strat Edge disclaims all warranties as to
            the accuracy, completeness, or adequacy of such information.
          </li>
          <li>
            The Site provides links to websites and access to content, products,
            and services from third parties, including users, advertisers,
            affiliates, and sponsors of the Site. The User agrees that Strat
            Edge is not responsible for the availability of, and content
            provided on, third-party websites. The User is requested to peruse
            the policies posted by other websites regarding privacy and other
            topics before use. Strat Edge is not responsible for third-party
            content accessible through the Site, including opinions, advice,
            statements, and advertisements, and the User shall bear all risks
            associated with the use of such content. Strat Edge is not
            responsible for any loss or damage of any sort that the User may
            incur from dealing with any third party.
          </li>
          <li>
            Strat Edge makes no warranty that: (a) the Site will meet your
            requirements; (b) the Site will be available on an uninterrupted,
            timely, secure, or error-free basis; (c) the results that may be
            obtained from the use of the Site or any services offered through
            the Site will be accurate or reliable.
          </li>
        </ul>
      </Container>
    </section>
  );
};

export default TermsOfUse;
